"use strict";

var _defineProperty = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Radio = require("@mui/material/Radio");
var _Radio2 = _interopRequireDefault(_Radio);
var _Button = require("@mui/material/Button");
var _Button2 = _interopRequireDefault(_Button);
var _QuestionContainer = require("../QuestionContainer");
var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _QuestionText = require("../QuestionText");
var _QuestionText2 = _interopRequireDefault(_QuestionText);
var _TextField = require("@mui/material/TextField");
var _TextField2 = _interopRequireDefault(_TextField);
var _Typography = require("@mui/material/Typography");
var _Typography2 = _interopRequireDefault(_Typography);
var _colors = require("@mui/material/colors");
var _useQuestionAnswer = require("../../hooks/use-question-answer");
var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Row = _styledComponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n"])));
var Label = (0, _styledComponents2.default)(_Typography2.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  && {\n    width: 120px;\n    padding-right: 8px;\n    font-weight: bold;\n    color: ", ";\n  }\n"])), _colors.grey[800]);
exports.default = function (_ref) {
  var question = _ref.question,
    onChangeAnswer = _ref.onChangeAnswer;
  var _ref2 = (0, _useQuestionAnswer2.default)(question, onChangeAnswer, {}),
    _ref3 = _slicedToArray(_ref2, 2),
    _ref3$ = _ref3[0],
    answer = _ref3$.answer,
    error = _ref3$.error,
    changeAnswer = _ref3[1];
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    error: error,
    answered: answer !== undefined
  }, question.items.map(function (item) {
    return _react2.default.createElement(Row, {
      key: item.name
    }, _react2.default.createElement(Label, null, item.title || item.name), _react2.default.createElement(_TextField2.default, {
      style: {
        flexGrow: 1
      },
      value: answer[item.name] || "",
      onChange: function onChange(e) {
        return changeAnswer(_objectSpread(_objectSpread({}, answer), {}, _defineProperty({}, item.name, e.target.value)));
      },
      id: question.id ? question.id : ""
    }));
  }));
};